import React from 'react';
import { Box } from '@mui/material';
import ItemSalesAndPurchaseSummary from '../../components/Reports/ItemSalesAndPurchaseSummary';

const ItemSalesAndPurchaseSummaryPage: React.FC = () => {
  return (
    <Box>
      <ItemSalesAndPurchaseSummary type="ITEM_SALES_AND_PURCHASE_SUMMARY" />
    </Box>
  );
};

export default ItemSalesAndPurchaseSummaryPage;
